import { Injectable } from '@angular/core';
import { BaseApiService } from 'src/app/shared/services/base-api/base-api.service';
import { GLOBAL_API_PATHS } from 'src/assets/constants/apiPaths';

@Injectable({
  providedIn: 'root'
})
export class FaqServiceService {

  constructor(private readonly baseApiService: BaseApiService) { }

  /**
   * getFaqdata() - Fetches FAQ data from the API.
   * @returns An observable containing the retrieved FAQ data.
   */
  getFaqdata(): any {
    let endpoint = GLOBAL_API_PATHS.faq_Data;
    return this.baseApiService.get(endpoint);
  }

   /**
   * addFaqData() - Sends new FAQ data to the API for storage.
   * @param data - The FAQ data to be posted to the server.
   */
  addFaqData(data): any {
    let endpoint = GLOBAL_API_PATHS.faq_Post;
    return this.baseApiService.post(endpoint, data);
  }

   /**
   * updateFaqData() - Updates existing FAQ data by sending changes to the API.
   * @param data - The modified FAQ data to be updated on the server.
   */
  updateFaqData(data): any {
    const endpoint = `${GLOBAL_API_PATHS.faq_edit}`;
    return this.baseApiService.put(endpoint, data);
  }

  /**
   * deleteFaqData() - Deletes an FAQ entry from the API.
   * @param data - The ID of the FAQ to be removed from the server.
   */
  deleteFaqData(data): any {
    const endpoint = `${GLOBAL_API_PATHS.faq_delete}?faqId=${data}`;
    return this.baseApiService.delete(endpoint);
  }

}
